/* eslint complexity: [1, 10] */
let prev_scroll_val = 0;
let is_contracted = false;
let block = false;
/**
 * Plots animations on the height of the body/scroll.
 */
export default class ScrollMachine {
  /**
   * Initializes event listeners and initial values for the class.
   * @param  {[number]} range range/resolution for the animation
   */
  constructor(range, scrollUpdateChecker) {
    this.updateThreshold();
    window.addEventListener('scroll', () => {
      if (!scrollUpdateChecker.checkScrollUpdate()) {
        return;
      }
      this.scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
      this.state.forEach(item => {

        // create sub-range for the item and give the current value to the callback
        item.callback(this.currentPos(item, range));
      });

      // check if temporarily blocked to prevent too much sensitivity
      if (!block) {
        if (prev_scroll_val > this.scrollY && is_contracted === true) {
          this.state_on_start.forEach(item => {
            item.onStartEnter();
            is_contracted = false;
          });
        } else if (this.scrollY > this.contracted_threshold && prev_scroll_val < this.scrollY && is_contracted === false) {
          this.state_on_start.forEach(item => {
            item.onStartLeave();
            is_contracted = true;
          });
        }

        // prevent changes of direction that are faster than 100ms
        block = true;

        setTimeout(() => {
          block = false;
        }, 100);

        prev_scroll_val = this.scrollY;
      } 
    }, {passive: true});

    // Make sure body height is up to date on scroll.
    window.addEventListener('resize', () => {
      this.updateThreshold();
      if (window.scrollY < window.innerHeight) {
        this.body_height = window.innerHeight;
      }
    });

    this.state = [];
    this.state_on_start = [];
    this.range = range;
    this.body_height = window.innerHeight;
    this.scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
  }

  /**
   * 
   * @returns base value for contracted threshold - lower if curtain turned off.
   */
  getThresholdBase() {
    return window.curtainSettings && window.curtainSettings.curtainEl ? window.innerHeight : 0;
  }

  /**
   * Updates this.contracted_threshold based on window size and whether the curtain is on or off.
   */
  updateThreshold() {
    this.contracted_threshold = this.getThresholdBase() + window.cmhrBetaBannerSettings.getCurrentSize('beta-banner-height-init') * 1.25;
  }

  /**
   * Calculate the current position of the given item.
   * @param  {[object]} item  current item
   * @param  {[number]} range range
   * @return {[number} current position of the item on its range
   */
  currentPos(item, range) {
    let level = (this.scrollY / this.body_height) * range;
    return Math.min(item.range, Math.max(0, ((level - item.min) / item.size) * item.range));
  }

  /**
   * Adds given range/callback on the stack.
   * @param {Number}  [min=0] starting position
   * @param {Number}  [max=400] ending position
   * @param {Number}  [range=100] resolution/range
   * @param {[Function]} [callback] callback that receives value of position on the range
   * @param {Boolean} [condition=true] optional condition
   * @return {Number} index value of array element
   */
  add(min = 0, max = 400, range = 100, callback, condition = true) {
    if (condition) {
      let newLength = this.state.push({
        min,
        max,
        size: max - min,
        range,
        callback
      });

      return newLength - 1;
    }
  }

  /**
   * Adds callbacks to be run on reaching the begining of a page and on leaving the begining of a page.
   * @param {[function]} onStartEnter A callback to be run on reaching the begining of the page.
   * @param {[function]} onStartLeave A callback to be run on leaving the begining of the page.
   */
  addOnStart(onStartEnter, onStartLeave) {
    this.state_on_start.push({ onStartEnter, onStartLeave });
  }

  /**
   * Runns all the onStartEnter functions from the state_on_start collection.
   */
  runOnStartEnter() {
    this.state_on_start.forEach(item => item.onStartEnter());
    is_contracted = false;
  }

  /**
   * Runns all the onStartLeave functions from the state_on_start collection.
   */
  runOnStartLeave() {
    this.state_on_start.forEach(item => item.onStartLeave());
    is_contracted = true;
  }

  /**
   * [updateItem description]
   * @param  {[Number]} index index of item to update
   * @param  {[Number]} min min of the range
   * @param  {[Number]} max max of the range
   * @param  {[Number]} range subrange resolution
   * @param  {[Function]} newCallback optional new callback
   */
  updateItem(index, min, max, range, newCallback) {
    if (this.state[index]) {
      let callback = newCallback ? newCallback : this.state[index].callback;

      this.state[index] = {
        min,
        max,
        size: max - min,
        range,
        callback
      };
    }
  }
};
